import { useScroll, useTransform } from "framer-motion";
import { FC, useEffect, useState } from "react";
import { DesktopNavigation, MobileNavigation } from "@tennr/frontend/components/Navigation";
import { useIsDesktop } from "@tennr/frontend/hooks/useMediaQuery";

export interface NavigationItem {
  title: string;
  to?: string; // used for internal links
  href?: string; // used for external links
  subitems?: NavigationItem[];
}

export interface NavigationProps {
  navigationItems: NavigationItem[];
  transparent?: boolean;
  hideNearFooter?: boolean;
}

export interface NavigationItemProps {
  item: NavigationItem;
  active?: boolean;
  disableDynamicText?: boolean;
  className?: string;
  onClick?: () => void;
}

export const Navigation: FC<Omit<NavigationProps, "transparent">> = ({ navigationItems }) => {
  const isDesktop = useIsDesktop();

  // remove transparent class when scroll position indicates we're covering content
  const { scrollYProgress } = useScroll({ offset: ["start start", "100vh start"] });
  const [isTransparent, setIsTransparent] = useState(true);
  const [hideNearFooter, setHideNearFooter] = useState(false);
  const showBackground = useTransform(scrollYProgress, (value) => value <= 0.4);
  const { scrollYProgress: footerScroll } = useScroll();

  useEffect(() => {
    const unsubscribe = showBackground.on("change", (value) => {
      setIsTransparent(value);
    });
    return () => unsubscribe();
  }, [showBackground]);

  useEffect(() => {
    const unsubscribe = footerScroll.on("change", (value) => {
      setHideNearFooter(value > 0.92);
    })
    return () => unsubscribe();
  }, [footerScroll])

  return isDesktop ? (
    <DesktopNavigation navigationItems={navigationItems} transparent={isTransparent} hideNearFooter={hideNearFooter} />
  ) : (
    <MobileNavigation navigationItems={navigationItems} transparent={isTransparent} />
  );
};
